<h2 mat-dialog-title>Generate BOQ from GIS</h2>

<mat-dialog-content>
  <p class="text-sm text-gray-600 mb-4">
    Quantities are derived from LRS route length and standard rate cards (road or utilities trench).
  </p>

  <div *ngIf="previewing" class="py-6 text-center text-gray-500 text-sm">Computing from geometry…</div>

  <div *ngIf="preview && !previewing" class="mb-4 p-3 rounded-lg bg-sky-50 text-sm text-sky-900">
    <p><strong>Route length:</strong> {{ preview.length.length_km }} km ({{ preview.length.source }})</p>
    <p><strong>Items:</strong> {{ preview.item_count }} · <strong>Estimated total:</strong> {{ formatCurrency(preview.total_amount) }}</p>
  </div>

  <form [formGroup]="form" class="grid grid-cols-1 gap-3">
    <mat-form-field appearance="outline">
      <mat-label>BoQ code</mat-label>
      <input matInput formControlName="boq_code">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>BoQ name</mat-label>
      <input matInput formControlName="boq_name">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Target BoQ type</mat-label>
      <mat-select formControlName="target">
        <mat-option value="standard">Standard BoQ</mat-option>
        <mat-option value="road">Road BoQ</mat-option>
      </mat-select>
    </mat-form-field>
    <ng-container *ngIf="form.value.target === 'road'">
      <mat-form-field appearance="outline">
        <mat-label>Administrative authority</mat-label>
        <input matInput formControlName="administrative_authority">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Road type</mat-label>
        <input matInput formControlName="road_type">
      </mat-form-field>
    </ng-container>
  </form>

  <div *ngIf="preview?.items?.length" class="mt-4 max-h-48 overflow-y-auto rounded border border-gray-200">
    <table class="min-w-full text-xs">
      <thead class="bg-gray-50 sticky top-0">
        <tr>
          <th class="px-2 py-1 text-left">Code</th>
          <th class="px-2 py-1 text-left">Description</th>
          <th class="px-2 py-1 text-right">Qty</th>
          <th class="px-2 py-1 text-right">Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of preview.items" class="border-t border-gray-100">
          <td class="px-2 py-1">{{ item.item_code }}</td>
          <td class="px-2 py-1">{{ item.item_description }}</td>
          <td class="px-2 py-1 text-right">{{ item.quantity }} {{ item.unit }}</td>
          <td class="px-2 py-1 text-right">{{ formatCurrency(item.final_line_total) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="dialogRef.close()">Cancel</button>
  <button mat-stroked-button type="button" (click)="runPreview()" [disabled]="previewing">Refresh preview</button>
  <button mat-raised-button color="primary" type="button" (click)="apply()"
    [disabled]="applying || !preview || form.invalid">
    {{ applying ? 'Creating…' : 'Create BoQ' }}
  </button>
</mat-dialog-actions>
